import { get, put,Delete,post } from '../axios'

// 用户升级记录-列表
export const upgradeRecordList = params => get(`/web/upgrade/record/list`,params);



